import { zergApi } from "@/service/zerg";
import axios from "axios";
class EntityGroupService {

    async getEntityGroup(params) {
        try {
            const data = await zergApi.post("setting/entity-group/get-entity-group", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async saveEntityGroup(params) {
        try {
            const data = await zergApi.post("setting/entity-group/save-entity-group", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getSelectUsers(params) {
        try {
            const data = await zergApi.post("setting/entity-group/get-select-users", params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getEntityGroupsOldSoft(params) {
        try {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded' // Aquí puedes cambiar el tipo de contenido
                }
            };
            const data = await axios.post('https://old.rosymarperu.in/server/public/index.php/cronjob/tareo/getEntityGroupsAndDetails', params, config)
            return data;
        } catch (error) {
            throw error;
        }
    }

    async updateEntityGroups(params) {
        try {
            const data = await zergApi.post("setting/entity-group/update-entity-groups", params);
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new EntityGroupService();